import { initializeApp } from "firebase/app";
import { getMessaging, onBackgroundMessage } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyBywxVSxwJ0oZVL5j5AFa0BY-QQmy_klhs",
  authDomain: "rembot-bbe71.firebaseapp.com",
  projectId: "rembot-bbe71",
  storageBucket: "rembot-bbe71.firebasestorage.app",
  messagingSenderId: "679451801245",
  appId: "1:679451801245:web:e66cec461c597b263c0674",
  measurementId: "G-9PQ7M4YBK1"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
